import { type AnyAction, combineReducers } from "redux";

import { StackPacksDetailsReducer } from "./details/StackPacksDetailsReducer";
import { StackPacksIndexReducer } from "./index/StackPacksIndexReducer";
import { CLEAR_STACK_PACKS_PAGE_STATE } from "./StackPacksActions";
import { type StackPacksState, initialStackPacksState } from "./StackPacksState";

const combinedReducers = combineReducers<StackPacksState>({
	index: StackPacksIndexReducer,
	details: StackPacksDetailsReducer,
});

export const StackPacksReducer = (state: StackPacksState, action: AnyAction) => {
	if (action.type === CLEAR_STACK_PACKS_PAGE_STATE) {
		return initialStackPacksState;
	}
	return combinedReducers(state, action);
};
